import classNames from 'classnames';
import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';

import { Box } from '@preventx/oxygen';

// Components
import { DefaultHero } from '@/slices/home/Hero/DefaultHero';
import { WithServices } from '@/slices/home/Hero/WithServices';
import { HeroWithBackgroundImage } from '@/slices/home/Hero/HeroWithBackgroundImage';
import { WithImagePlusHeroColumns } from '@/slices/home/Hero/WithImagePlusHeroColumns';

export type HeroProps = SliceComponentProps<Content.HeroSlice>;

const Hero = ({ slice }: HeroProps) => {
  const { id, variation } = slice;

  return (
    <Box
      component={variation !== 'withServices' ? 'div' : 'section'}
      variant={variation === 'withBackgroundImage' ? 'solid' : undefined}
      className={classNames({
        region: variation === 'default' || variation === 'withServices',
        masthead:
          variation !== 'default' &&
          variation !== 'withServices' &&
          variation !== 'withImageHeroColumns',
        hero:
          variation === 'default' ||
          variation === 'withServices' ||
          variation === 'withBackgroundImage' ||
          variation === 'withImageHeroColumns',
      })}
    >
      {variation === 'withServices' && <WithServices slice={slice} />}
      {variation === 'default' && <DefaultHero id={id} slice={slice} />}
      {variation === 'withBackgroundImage' && (
        <HeroWithBackgroundImage slice={slice} />
      )}
      {variation === 'withImageHeroColumns' && (
        <WithImagePlusHeroColumns slice={slice} />
      )}
    </Box>
  );
};

export default Hero;
